import { Grid, TextField, Button } from "@mui/material";
import { Courses } from "@backend-types";
import { UserManagementModal } from "../UserManagementModal";
import { makeStyles } from "@mui/styles";
import { generateGtmEvent } from "../../../../Helpers";

const useStyles = makeStyles({
  textField: {
    "& .MuiFormLabel-root": {
      fontWeight: 500,
      fontSize: 14,
      color: "#747474",
      textTransform: "uppercase",
      letterSpacing: 0.7,
    },
    "& .MuiInputBase-root": {
      color: "#484848",
      borderBottom: "none !important",
      fontSize: 16,
      fontWeight: 400,
      paddingBottom: "1rem",
      "& .Mui-disabled": {
        "-webkit-text-fill-color": "unset",
      },
    },
  },
  borderBottom: {
    width: "100%",
    borderBottom: "1px solid #E8E8E8",
  },
});

export type ViewCourseProps = {
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
  course?: Courses;
};

export function ViewCourse(props: ViewCourseProps) {
  const classes = useStyles();

  if (props.course) {
    const title = `${props.course.name}`;

    const fieldProps = {
      fullWidth: true,
      disabled: true,
      className: classes.textField,
      InputProps: {
        disableUnderline: true,
      },
    };

    const divider = <div className={classes.borderBottom} />;
    const HandleDataLayer = (
      event: string,
      action: string,
      name: string,
      type: string,
      region: string,
      section: string,
      text: string
    ) => {
      generateGtmEvent({ event, action, name, type, region, section, text });
    };

    return (
      <UserManagementModal
        hideSubmitButton={true}
        title={title}
        titleElem={
          <>
            {title}
            <Button
              variant="outlined"
              size={"small"}
              disableElevation
              sx={{
                marginLeft: "1em",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "primary.light",
                },
              }}
              onClick={() => {
                HandleDataLayer(
                  "link",
                  "click",
                  "onclick",
                  "internal link",
                  "modal",
                  title,
                  "edit"
                );
                props.onEdit();
              }}>
              Edit
            </Button>
          </>
        }
        open={props.open}
        onClose={props.onClose}>
        <Grid container spacing={6}>
          <Grid item xs={6} order={1}>
            <TextField
              label="Deep Link Type"
              variant="standard"
              value={
                props.course.metadata.deeplink_asset_type
                  ? props.course.metadata.deeplink_asset_type.charAt(0).toUpperCase() +
                    props.course.metadata.deeplink_asset_type.slice(1)
                  : ""
              }
              {...fieldProps}
            />
            {divider}
          </Grid>
          <Grid item xs={6} order={1}>
            <TextField
              label="Grading Method"
              variant="standard"
              {...fieldProps}
              value={
                props.course.metadata.lti_grading_method
                  ? props.course.metadata.lti_grading_method.charAt(0).toUpperCase() +
                    props.course.metadata.lti_grading_method.slice(1)
                  : ""
              }
            />
            {divider}
          </Grid>
          <Grid item xs={6} order={2}>
            <TextField
              label="Module Locking"
              variant="standard"
              {...fieldProps}
              value={
                props.course.metadata.use_digit_study_tool ?? false ? "True" : "False"
              }
            />
            {divider}
          </Grid>
          <Grid item xs={6} order={2}>
            <TextField label="Score Type" variant="standard" {...fieldProps} />
            {divider}
          </Grid>
          <Grid item xs={6} order={3}>
            <TextField
              label="Module Order"
              variant="standard"
              {...fieldProps}
              value={props.course.metadata?.show_module_order ?? false ? "True" : "False"}
            />
            {divider}
          </Grid>
          <Grid item xs={6} order={3}>
            <TextField
              label="Assessment Metrics"
              variant="standard"
              value={
                props.course.metadata?.management_page?.assessment_metrics_type ?? false
                  ? props.course.metadata?.management_page?.assessment_metrics_type
                  : "activity-tye-count"
              }
              {...fieldProps}
            />
            {divider}
          </Grid>
          <Grid item xs={6} order={4}>
            <TextField
              label="Show submodule progress bar"
              variant="standard"
              {...fieldProps}
              value={
                props.course.metadata?.management_page?.show_submodule_progress ?? false
                  ? "True"
                  : "False"
              }
            />
            {divider}
          </Grid>
        </Grid>
      </UserManagementModal>
    );
  } else {
    return <></>;
  }
}
